import { z } from 'zod';
import { uuidSchema } from './common.js';

/**
 * RUF-569: mock payment method on a customer_org's buyer profile — the
 * foundation the (separate, later) RUF-570 escrow-deposit slice charges
 * against. NO real payment-instrument fields — label + a display-only masked
 * identifier only.
 */
export const paymentMethodDetailSchema = z.object({
  id: uuidSchema,
  label: z.string(),
  maskedIdentifier: z.string(),
  isDefault: z.boolean(),
  /** Always true — this is a mock/test payment method (RUF-569/570). */
  isMock: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PaymentMethodDetail = z.infer<typeof paymentMethodDetailSchema>;

export const paymentMethodListResponseSchema = z.object({
  data: z.array(paymentMethodDetailSchema),
});
export type PaymentMethodListResponse = z.infer<typeof paymentMethodListResponseSchema>;

export const paymentMethodCreateSchema = z.object({
  label: z.string().min(1).max(120),
  maskedIdentifier: z.string().min(1).max(60),
  /**
   * Optional: request this method become the org's default. Ignored (always
   * true) for an org's first payment method — the API forces the first
   * method to be the default regardless of this flag.
   */
  isDefault: z.boolean().optional(),
});
export type PaymentMethodCreate = z.infer<typeof paymentMethodCreateSchema>;

export const paymentMethodUpdateSchema = z.object({
  label: z.string().min(1).max(120).optional(),
  maskedIdentifier: z.string().min(1).max(60).optional(),
  isDefault: z.boolean().optional(),
}).strict();
export type PaymentMethodUpdate = z.infer<typeof paymentMethodUpdateSchema>;
